import { useState, useEffect } from 'react'
import { Download, X } from 'lucide-react'
import { showInstallPrompt, isPWAInstalled } from '@/utils/serviceWorker'

const PWAInstallBanner = () => {
  const [showBanner, setShowBanner] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    // Don't show if already installed or dismissed
    if (isPWAInstalled() || dismissed) {
      return
    }

    // Show banner after a delay if PWA is not installed
    const timer = setTimeout(() => {
      const hasBeenDismissed = localStorage.getItem('pwa-install-dismissed')
      if (!hasBeenDismissed) {
        setShowBanner(true)
      }
    }, 5000) // Show after 5 seconds

    return () => clearTimeout(timer)
  }, [dismissed])

  const handleInstall = async () => {
    const installed = await showInstallPrompt()
    if (installed) {
      setShowBanner(false)
    }
  }

  const handleDismiss = () => {
    setShowBanner(false)
    setDismissed(true)
    localStorage.setItem('pwa-install-dismissed', 'true')
  }

  if (!showBanner) {
    return null
  }

  return (
    <div
      id="pwa-install-banner"
      className="fixed bottom-4 left-4 right-4 bg-primary-600 text-white rounded-lg shadow-lg p-4 z-50 md:left-auto md:right-4 md:w-96"
    >
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <Download className="w-6 h-6" />
        </div>
        
        <div className="flex-1">
          <h3 className="font-medium text-white">Install BonnyCloud</h3>
          <p className="text-sm text-primary-100 mt-1">
            Install our app for a better experience with offline support and quick access.
          </p>
          
          <div className="flex space-x-2 mt-3">
            <button
              onClick={handleInstall}
              className="bg-white text-primary-600 px-3 py-1.5 rounded text-sm font-medium hover:bg-primary-50 transition-colors"
            >
              Install
            </button>
            <button
              onClick={handleDismiss}
              className="text-primary-100 hover:text-white px-3 py-1.5 rounded text-sm transition-colors"
            >
              Not now
            </button>
          </div>
        </div>
        
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 text-primary-200 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}

export default PWAInstallBanner